<template>
  <div
    v-if="noPackages || noPolicies"
    class="flex-col justify-content-center align-items-center gap-sm mt-xl"
  >
    <AlertCircleOutlineIcon class="icon-size-xxl fill-primary color-primary"></AlertCircleOutlineIcon>
    <h3 class="text-center">{{ notFoundMessage }}</h3>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  props: {
    noPolicies: {
      type: Boolean
    },
    noPackages: {
      type: Boolean
    },
    filterActive: {
      type: Boolean
    },
  },
  computed: {
    notFoundMessage() {
      let subject = '';
      let filter = this.filterActive ? ' die aan het huidige filter voldoen.' : '.';

      if (this.noPolicies && this.noPackages) {
        subject = (this.filterActive ? '' : 'nog ') + 'geen polissen of pakketten';
      } else if (this.noPolicies) {
        subject = 'geen polissen';
      } else if (this.noPackages) {
        subject = 'geen pakketten';
      }

      return `Er zijn ${subject} voor deze klant${filter}`
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
